import { catchError, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { Observable } from "rxjs";

import { UserService } from "../../shared/user.service";
import { DiscussionService } from "../discussion.service";
import { Discussion } from "../../../models";

@Injectable()
export class EditableDiscussionResolver implements Resolve<Discussion> {
  constructor(
    private discussionService: DiscussionService,
    private router: Router,
    private userService: UserService
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const discussionSlug = route.params["discussion"];

    return this.discussionService.findOne(discussionSlug).pipe(
      map((discussion) => {
        if (
          this.userService.getCurrentUser().username ===
          discussion.author.username
        ) {
          return discussion;
        } else {
          this.router.navigateByUrl("/");
        }
      }),
      catchError((err) => this.router.navigateByUrl("/"))
    );
  }
}
